import { SET_VISIBILITY, SET_TITLE, SET_ITEM, SET_FORCED_SCROLL_BOTTOM } from './navigation-drawer-mutation-types'
import { RESET } from './mutation-types'
import store from '@/store'
import { getContactImg } from '@/store/utils'

export const messageDrawer = {
  namespaced: true,
  state: {
    visible: true,
    title: '',
    item: null,
    forcedScrollBottom: true,
    outbondOpts: {
      nextOutPageNumber: '',
      nextOutPageToken: ''
    },
    inbondOpts: {
      nextInPageNumber: '',
      nextInPageToken: ''
    }
  },
  getters: {
    getVisibility: (state) => {
      return state.visible
    },
    getTitle: (state) => {
      return state.title
    },
    getItem: (state) => {
      return state.item
    },
    getContactAvatar: (state) => {
      return getContactImg(state.item)
    },
    getForcedScrollBottom: (state) => {
      return state.forcedScrollBottom
    }
  },
  actions: {
    setVisibility ({ commit }, { val }) {
      commit(SET_VISIBILITY, { val })
    },
    setForcedScrollBottom ({ commit }, { val }) {
      commit(SET_FORCED_SCROLL_BOTTOM, { val })
    },
    reset ({ commit }) {
      commit(RESET)
    },
    setTitle ({ commit }, { val }) {
      commit(SET_TITLE, { val })
    },
    async setItem ({ commit }, { val, forced }) {
      commit(SET_ITEM, { val, forced })
    }

  },
  mutations: {
    [SET_VISIBILITY] (state, { val }) {
      state.visible = val
    },
    [RESET] (state) {
      state.visible = false
      state.title = ''
      store.dispatch('message/reset')
    },
    [SET_TITLE] (state, { val }) {
      state.title = val
    },
    [SET_FORCED_SCROLL_BOTTOM] (state, { val }) {
      state.forcedScrollBottom = val
    },
    [SET_ITEM] (state, { val, forced }) {
      if ((!val || state.item === val) && !forced) return
      state.item = val
      state.title = state.item.name + ' ' + state.item.lastName

      if (!forced && !state.visible) return
      const outbondOpts = state.outbondOpts.nextOutPageToken ? state.outbondOpts : {}
      const inbondOpts = state.inbondOpts.nextInPageToken ? state.inbondOpts : {}
      store.dispatch('message/pullMessages', { init: true, contact: val, outbondOpts, inbondOpts })
    }
  }
}
